import {Text, Pressable, StyleSheet} from "react-native";
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';

/**
 * This sesion view button is ONLY VISIBLE for camp owners when viewing their own camp page.
 * 
 * A floating action button that toggles between sessions view and general information view.
 * 
 * @param {boolean} isSessionView - Current session view state
 * @param {function} setIsSessionView - Function to toggle session view state
 */
const SessionViewButton = ({isCampHost, isSessionView, setIsSessionView}) => {

    return (
        <Pressable 
            style={styles.button}
            onPress={() => setIsSessionView(!isSessionView)}
        >
            <MaterialCommunityIcons 
                name={isSessionView ? 'campfire' : 'format-list-bulleted'} 
                size={20}
                color='white'
            />
            <Text style={styles.buttonText}>
                {isSessionView ? 'View General Info' : 'View Camp Sessions'}
            </Text>
        </Pressable>
    );
};

const styles = StyleSheet.create({
    button: {
        backgroundColor: 'black',
        borderRadius: 40,
        paddingVertical: 12,
        paddingHorizontal: 16,
        flexDirection: 'row',
        alignItems: 'center',
        minWidth: 200,
        justifyContent: 'center',
    },
    buttonText: {
        fontSize: 16,
        color: 'white',
        fontWeight: '600',
        marginLeft: 8
    }
});

export default SessionViewButton;